import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import {
  AgreementsAutocomplete,
  LevelsAutocomplete,
  Form,
} from "@shared/components";

export function PlanForm({ agreement }: { agreement?: string }) {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="name"
          label={translate("subscription_plan_admin.fields.name")}
          required
        />
      </Grid>

      {!agreement && (
        <Grid size={{ xs: 6 }}>
          <AgreementsAutocomplete
            name="agreement"
            label={translate("subscription_plan_admin.fields.agreement")}
            required
          />
        </Grid>
      )}

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="target"
          label={'Tipo de Assinatura'}
          options={[
            { value: "company", label: "Para Empresas (SaaS)" },
            { value: "user", label: "Para Usuários (Assinatura)" },
          ]}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="plan_types"
          multiple
          label={"Tipo de Plano"}
          options={[
            { value: "club", label: "Clube" },
            { value: "book", label: "Livros" },
            { value: "magazine", label: "Revistas" },
          ]}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <LevelsAutocomplete
          name="level"
          label={translate("subscription_plan_admin.fields.level")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="access_amount"
          type="number"
          label={translate("subscription_plan_admin.fields.access_amount")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="value"
          mask={"currency"}
          label={translate("subscription_plan_admin.fields.value")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_page"
          label={translate("subscription_plan_admin.fields.vindi_page")}
          instructions={translate(
            "subscription_plan_admin.instructions.vindi_page"
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_token"
          label={translate("subscription_plan_admin.fields.vindi_token")}
          instructions={translate(
            "subscription_plan_admin.instructions.vindi_token"
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="slug"
          label={translate("subscription_plan_admin.fields.slug")}
          instructions={translate("subscription_plan_admin.instructions.slug")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="audiobook_quantity"
          type="number"
          label={translate("subscription_plan_admin.fields.audiobook_quantity")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="book_quantity"
          type="number"
          label={translate("subscription_plan_admin.fields.book_quantity")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="magazine_quantity"
          type="number"
          label={translate("subscription_plan_admin.fields.magazine_quantity")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Checkbox
          name="default"
          label={translate("subscription_plan_admin.fields.default")}
        />
      </Grid>
    </Grid>
  );
}
